import { Optional } from "src/types";

export const concatClasses = (...classes: Optional<string>[]) => {
  return classes?.filter((x) => x)?.join(" ");
};

export const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

export const deepCopy = <T>(thing: T): T => {
  try {
    return JSON.parse(JSON.stringify(thing));
  } catch (e) {
    return thing;
  }
};

export const deleteKey = <T extends Record<string, unknown>>(
  record: T,
  key = ""
): T => {
  const recordCopy = deepCopy(record);
  delete recordCopy?.[key];
  return recordCopy;
};

export const deleteEmptyKeys = <T extends Record<string, unknown>>(
  record: T
): T => {
  const recordCopy = deepCopy(record);
  Object.entries(recordCopy).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") {
      delete recordCopy?.[key];
    }
  });
  return recordCopy;
};
